import * as React from 'react';
import {formatClasses} from '@pluto-tv/assemble';

export interface ILogoProps {
  expanded: boolean;
}

const Logo = React.memo(({expanded}: ILogoProps) => {
  const minLogoClass = React.useMemo(() => {
    const classes = ['logo-min'];

    if (!expanded) {
      classes.push('logo-visible');
    }

    return formatClasses(classes);
  }, [expanded]);

  const expandedLogoClass = React.useMemo(() => {
    const classes = ['logo-full'];

    if (expanded) {
      classes.push('logo-visible');
    }

    return formatClasses(classes);
  }, [expanded]);

  return (
    <div className='logo'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='2.34rem'
        height='1.5rem'
        viewBox='0 0 37 24'
        version='1.1'
        preserveAspectRatio='xMinYMin meet'
        className={minLogoClass}
      >
        <g id='Symbols' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
          <g
            id='Project-specific-components/Sidebar/Collapsed'
            transform='translate(-5.000000, -6.000000)'
            fillRule='nonzero'
          >
            <g id='Group' transform='translate(5.000000, 6.000000)'>
              <g id='Path'>
                <path
                  d='M13.9488,12 C13.9488,2.5712 14.8352,0.1968 14.8352,0.1968 L12.0352,0.2536 C5.408,0.3888 0.0352,5.372 0.0352,12 C0.0352,18.6272 5.408,23.6112 12.0352,23.7464 L14.8352,23.8032 C14.8352,23.8032 13.9488,21.4288 13.9488,12 Z'
                  fill='#FF2CD2'
                />
                <path
                  d='M13.9488,12 C13.9488,4.4528 18.0384,0.1312 18.0384,0.1312 L14.8352,0.1968 C8.208,0.332 2.8352,5.3728 2.8352,12 C2.8352,18.6272 8.208,23.668 14.8352,23.8032 L18.0384,23.8688 C18.0392,23.8688 13.9488,19.5472 13.9488,12 Z'
                  fill='#5E00FF'
                />
                <path
                  d='M13.9488,12 C13.9488,3.48 21.2424,0.0656 21.2424,0.0656 L18.0392,0.1312 C11.412,0.2664 6.0392,5.3728 6.0392,12 C6.0392,18.6272 11.412,23.7336 18.0392,23.8688 L21.2424,23.9352 C21.2424,23.9352 13.9488,20.5208 13.9488,12 Z'
                  fill='#FFDE2B'
                />
                <path
                  d='M13.9488,12 C13.9488,6.448 17.5624,0.6816 23.992,0.0096 L21.2416,0.0664 C14.6144,0.2016 9.2416,5.3728 9.2416,12.0008 C9.2416,18.628 14.6144,23.7992 21.2416,23.936 L24.0008,23.992 C17.5744,23.3224 13.9488,17.552 13.9488,12 Z'
                  fill='#FF6700'
                />
              </g>
              <path
                d='M24.4448,0 C17.8176,0 12.4448,5.3728 12.4448,12 C12.4448,18.6272 17.8176,24 24.4448,24 C31.072,24 36.4448,18.6272 36.4448,12 C36.4448,5.3728 31.0728,0 24.4448,0 Z M29.184,17.8608 L26.9472,17.8608 L23.7448,10.1144 L20.5328,10.1144 L20.5328,14.1112 C20.5328,14.972 20.948,15.5064 21.9264,15.5064 L23.3464,15.5064 L23.3464,17.8608 L21.6008,17.8608 C19.2328,17.8608 17.964,16.5208 17.964,14.2816 L17.964,10.1144 L16.1928,10.1144 L16.1928,7.8624 L17.964,7.8624 L17.964,6.2616 L20.5328,5.224 L20.5328,7.8624 L25.588,7.8624 L28.0648,14.3328 L30.5656,7.8008 L33.3424,7.8008 L29.184,17.8608 Z'
                id='Shape'
                fill='#FFFFFF'
              />
            </g>
          </g>
        </g>
      </svg>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='13.4375rem'
        height='2.1875rem'
        viewBox='0 0 215 35'
        version='1.1'
        preserveAspectRatio='xMinYMin meet'
        className={expandedLogoClass}
      >
        <g id='Symbols' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
          <g
            id='Project-specific-components/Sidebar/Expanded'
            transform='translate(-12.000000, -7.000000)'
            fillRule='nonzero'
          >
            <g id='Group' transform='translate(12.000000, 7.000000)'>
              <path
                d='M59.4050625,3.65238068 C55.0949489,3.65238068 51.6011932,7.14613636 51.6011932,11.45625 C51.6011932,15.7663636 55.0949489,19.2601193 59.4050625,19.2601193 C63.7151761,19.2601193 67.2089318,15.7663636 67.2089318,11.45625 C67.2089318,7.14613636 63.7151761,3.65238068 59.4050625,3.65238068 Z M59.4050625,15.0405341 C57.4254545,15.0405341 55.8207784,13.435858 55.8207784,11.45625 C55.8207784,9.47664205 57.4254545,7.87196591 59.4050625,7.87196591 C61.3846705,7.87196591 62.9893466,9.47664205 62.9893466,11.45625 C62.9893466,13.435858 61.3846705,15.0405341 59.4050625,15.0405341 Z M46.8961193,7.96890341 L46.8961193,12.801358 C46.8961193,14.2834602 47.5570568,14.9435966 49.038358,14.9435966 L50.5316761,14.9435966 L50.5316761,18.9645 L48.3589943,18.9645 C46.5516307,18.9645 45.0647216,18.4341477 44.0576932,17.4319261 C43.052267,16.4305057 42.5203125,14.951608 42.5203125,13.1562614 L42.5203125,7.96890341 L39.8276932,7.96890341 L39.8276932,3.948 L42.5203125,3.948 L42.5203125,1.77531818 L46.8961193,0.00721022727 L46.8961193,3.948 L50.5316761,3.948 L50.5316761,7.96890341 L46.8961193,7.96890341 Z M38.1140625,3.95040341 L38.1140625,12.1660568 C38.1140625,16.0844148 34.9375568,19.2609205 31.0191989,19.2609205 C27.1008409,19.2609205 23.9243352,16.0844148 23.9243352,12.1660568 L23.9243352,5.869125 L28.2705,4.11303409 L28.2705,12.2918352 C28.2705,13.8099886 29.5010455,15.0405341 31.0191989,15.0405341 C32.5373523,15.0405341 33.7678977,13.8099886 33.7678977,12.2918352 L33.7678977,5.70569318 L38.1140625,3.95040341 Z M22.0424659,0.00721022727 L22.0424659,18.9645 L17.6666591,18.9645 L17.6666591,1.77531818 L22.0424659,0.00721022727 Z M8.68832386,3.65398295 C6.86013068,3.65398295 5.30913068,4.27165909 4.15629545,5.45013068 L3.55223864,3.98805682 L0.0144204545,5.41728409 L0.0144204545,22.9052898 L4.38942614,22.9052898 L4.38942614,17.7411648 C5.52784091,18.7682216 7.00113068,19.2593182 8.689125,19.2593182 C10.6879602,19.2593182 12.5329773,18.4469659 13.8844943,16.9720739 C15.2135795,15.5212159 15.9458182,13.5672443 15.9458182,11.4714716 C15.945017,7.08765341 12.7572955,3.65398295 8.68832386,3.65398295 Z M8.019375,15.0405341 C6.00852273,15.0405341 4.37821023,13.435858 4.37821023,11.45625 C4.37821023,9.47664205 6.00852273,7.87196591 8.019375,7.87196591 C10.0302273,7.87196591 11.6605398,9.47664205 11.6605398,11.45625 C11.6605398,13.435858 10.0310284,15.0405341 8.019375,15.0405341 Z'
                id='Shape'
                fill='#FFFFFF'
              />
              <g transform='translate(69.378409, 3.605114)'>
                <g id='Path'>
                  <path
                    d='M9.06966477,7.85113636 C9.06966477,1.71923864 9.64568265,0.175448864 9.64568265,0.175448864 L7.82469886,0.212301136 C3.51458523,0.300426136 0.0208295455,3.54102273 0.0208295455,7.85113636 C0.0208295455,12.16125 3.51458523,15.4018466 7.82469886,15.4899716 L9.64568265,15.5268242 C9.64648295,15.527625 9.06966477,13.9830341 9.06966477,7.85113636'
                    fill='#FF2CD2'
                  />
                  <path
                    d='M9.06966477,7.85113636 C9.06966477,2.943375 11.7294375,0.1321875 11.7294375,0.1321875 L9.64568182,0.174647727 C5.33556818,0.262772727 1.8418125,3.54102273 1.8418125,7.85033523 C1.8418125,12.1604489 5.33556818,15.4386989 9.64568182,15.5260227 L11.7294375,15.5684836 C11.7294375,15.5700852 9.06966477,12.7596989 9.06966477,7.85113636'
                    fill='#5E00FF'
                  />
                  <path
                    d='M9.06966477,7.85113636 C9.06966477,2.30967614 13.8131932,0.0897272727 13.8131932,0.0897272727 L11.7302386,0.1321875 C7.420125,0.2203125 3.92636932,3.54102273 3.92636932,7.85113636 C3.92636932,12.16125 7.420125,15.4819602 11.7302386,15.5700852 L13.8131932,15.6133466 C13.8131932,15.6133466 9.06966477,13.3925966 9.06966477,7.85113636'
                    fill='#FFDE2B'
                  />
                  <path
                    d='M9.06966477,7.85113636 C9.06966477,4.24041477 11.4193977,0.490295455 15.6013295,0.052875 L13.8131932,0.0897272727 C9.50307955,0.177852273 6.00932386,3.54102273 6.00932386,7.85113636 C6.00932386,12.16125 9.50307955,15.5244205 13.8131932,15.6133466 L15.6077386,15.6493977 C11.4274091,15.2143807 9.06966477,11.461858 9.06966477,7.85113636'
                    fill='#FF6700'
                  />
                </g>
                <path
                  d='M15.8961477,0.0472670455 C11.5860341,0.0472670455 8.09227841,3.54102273 8.09227841,7.85113636 C8.09227841,12.16125 11.5860341,15.6550057 15.8961477,15.6550057 C20.2062614,15.6550057 23.700017,12.16125 23.700017,7.85113636 C23.700017,3.54102273 20.2054602,0.0472670455 15.8961477,0.0472670455 Z M18.9773182,11.6629432 L17.5224545,11.6629432 L15.4395,6.62539773 L13.3509375,6.62539773 L13.3509375,9.22428409 C13.3509375,9.78427841 13.6209205,10.1311705 14.2578239,10.1311705 L15.1815341,10.1311705 L15.1815341,11.662142 L14.0463239,11.662142 C12.5057386,11.662142 11.6813693,10.7905057 11.6813693,9.33484091 L11.6813693,6.62539773 L10.5293352,6.62539773 L10.5293352,5.16092045 L11.6813693,5.16092045 L11.6813693,4.12024432 L13.3517386,3.4456875 L13.3517386,5.16172159 L16.6396023,5.16172159 L18.2506875,9.36928977 L19.8769943,5.12166477 L21.6827557,5.12166477 L18.9773182,11.6629432 Z'
                  id='Shape'
                  fill='#FFFFFF'
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
});

Logo.displayName = 'Logo';
export default Logo;
